module.exports = __webpack_public_path__ + "img/ab2.af67ef12.png";